import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import NebulaInspector from "./NebulaInspector";
import "./styles/index.scss";

render(<NebulaInspector />, document.getElementById('react'));